// @flow
export const IDENTIFIERS = {
  AUTOCOMPLETE: 'autocomplete',
  BUBBLE: 'bubble',
  BUTTON: 'button',
  CHECKBOX: 'checkbox',
  DROPDOWN: 'dropdown',
  FLEX: 'flex',
  FORM_FIELD: 'formfield',
  GRID: 'grid',
  GUTTER: 'gutter',
  HEADER: 'header',
  INFINITE_SCROLL: 'infinitescroll',
  INPUT: 'input',
  LINK: 'link',
  LOADING_SPINNER: 'loadingspinner',
  MODAL: 'modal',
  OPTIONS: 'options',
  PASSWORD_INPUT: 'passwordInput',
  POP_OVER: 'popOver',
  PROGRESS_BAR: 'progressbar',
  RADIO: 'radio',
  SCROLLBAR: 'scrollbar',
  SELECT: 'select',
  STEPPER: 'stepper',
  SWITCH: 'switch',
  TEXT_AREA: 'textarea',
  TOGGLER: 'toggler',
  TOOLTIP: 'tooltip',
};
